module.exports = __webpack_public_path__ + "static/media/ASB6000 - 1.3c7dadab.jpeg";